import React from 'react';
import { Box, CircularProgress, IconButton, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TextWithIcon from '../TextWithIcon';
import FileIcon from '../File/FileIcon';

const ICON_SIZE = 20;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    border: '1px solid var(--attachments-border-color)',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1),
    position: 'relative',
  },
  delete: {
    background: 'white',
    position: 'absolute',
    right: theme.spacing(-1.75),
    top: theme.spacing(-1.75),
  },
  icon: {
    alignItems: 'center',
    display: 'inline-flex',
    flex: 0,
    height: ICON_SIZE,
    justifyContent: 'center',
    width: ICON_SIZE,
  },
}));

interface Props {
  completed?: boolean;
  deletable?: boolean;
  disabled?: boolean;
  filename: string;
  mime: string;
  onDelete?: () => void;
  uploading?: boolean;
}

const Attachment: React.FC<Props> = (props: Props) => {
  const {
    completed = false,
    deletable = false,
    disabled = false,
    filename,
    mime,
    onDelete,
    uploading = false,
  } = props;

  const classes = useStyles();

  const isDeletable = deletable && !(completed || disabled || uploading);

  const renderIcon = () => {
    if (completed) {
      return <CheckCircleOutlineIcon color="secondary" fontSize="small" />;
    }
    if (uploading) {
      return <CircularProgress color="secondary" size={ICON_SIZE} />;
    }
    return <FileIcon disabled={disabled} mimeType={mime} />;
  };

  return (
    <Box className={classes.root}>
      <TextWithIcon
        disableTextPadding
        icon={<Box className={classes.icon}>{renderIcon()}</Box>}
        text={filename}
        variant="body2"
      />
      {isDeletable && (
        <IconButton className={classes.delete} onClick={onDelete} size="small">
          <CancelIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default Attachment;
